"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = meeting;
exports.initialState = void 0;
var _types = require("../../actions/meeting/types");
var _types2 = require("../../actions/attendee/types");
var _Meeting = require("@studio/constants/Meeting");
var _ScreenShareStatus = require("@studio/constants/ScreenShareStatus");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = exports.initialState = {
  started: false,
  attendeeTiles: {},
  mixerTile: undefined,
  presenterAttendeeIds: [],
  attendeeId: null,
  meetingId: null,
  mixerAttendeeIds: [],
  screenShare: {
    client: null,
    videoTrack: null,
    audioTrack: null,
    status: _ScreenShareStatus.SCREEN_SHARE_STATUS.IDLE
  },
  status: _Meeting.MEETING_STATUS.PENDING
};
function meeting() {
  var _action$payload3;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_CLEAR_MEETING) {
    return initialState;
  }
  if (action.type === _types.BROADCAST_CREATE_MEETING || action.type === _types.BROADCAST_JOIN_MEETING_AS_MIXER) {
    return _objectSpread(_objectSpread({}, state), {}, {
      started: true
    });
  }
  if (action.type === "".concat(_types.BROADCAST_CREATE_MEETING, "_FAILURE") || action.type === "".concat(_types.BROADCAST_JOIN_MEETING_AS_MIXER, "_FAILURE")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      started: false
    });
  }
  if (action.type === "".concat(_types.BROADCAST_CREATE_MEETING, "_SUCCESS") || action.type === "".concat(_types.BROADCAST_JOIN_MEETING_AS_MIXER, "_SUCCESS")) {
    return _objectSpread(_objectSpread(_objectSpread({}, state), action.payload), {}, {
      started: state.started
    });
  }
  if (action.type === "".concat(_types.BROADCAST_SET_MIXER_TILE)) {
    var tileState = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      mixerTile: tileState
    });
  }
  if (action.type === _types.ADD_TO_ATTENDEE_TILES) {
    var _action$payload = action.payload,
      attendeeTile = _action$payload.attendeeTile,
      attendeeId = _action$payload.attendeeId;
    return _objectSpread(_objectSpread({}, state), {}, {
      attendeeTiles: _objectSpread(_objectSpread({}, state.attendeeTiles), {}, _defineProperty({}, attendeeId, attendeeTile))
    });
  }
  if (action.type === "".concat(_types2.BROADCAST_SET_ATTENDEE_TILE)) {
    var _tileState = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      attendeeTiles: _objectSpread(_objectSpread({}, state.attendeeTiles), {}, _defineProperty({}, _tileState.boundAttendeeId, [_tileState]))
    });
  }
  if (action.type === _types2.BROADCAST_SET_MIXER_ATTENDEE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      mixerAttendeeIds: [].concat(_toConsumableArray(state.mixerAttendeeIds), [action.payload])
    });
  }
  if (action.type === _types2.BROADCAST_SYNC_PRESENTER_ATTENDEE_IDS) {
    return _objectSpread(_objectSpread({}, state), {}, {
      presenterAttendeeIds: [].concat(_toConsumableArray(state.presenterAttendeeIds), _toConsumableArray(action.payload))
    });
  }
  if (action.type === _types.UPDATE_MEETING_STATUS) {
    return _objectSpread(_objectSpread({}, state), {}, {
      status: action.payload
    });
  }
  if (action.type === "".concat(_types2.START_AGORA_SCREENSHARE, "_SUCCESS")) {
    var _action$payload2 = action.payload,
      screenShareClient = _action$payload2.screenShareClient,
      screenVideoTrack = _action$payload2.screenVideoTrack,
      screenAudioTrack = _action$payload2.screenAudioTrack;
    return _objectSpread(_objectSpread({}, state), {}, {
      screenShare: {
        client: screenShareClient,
        videoTrack: screenVideoTrack,
        audioTrack: screenAudioTrack,
        status: _ScreenShareStatus.SCREEN_SHARE_STATUS.ACTIVE
      }
    });
  }
  if (action.type === _types2.START_AGORA_SCREENSHARE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      screenShare: _objectSpread(_objectSpread({}, state.screenShare), {}, {
        status: _ScreenShareStatus.SCREEN_SHARE_STATUS.STARTING
      })
    });
  }
  if (action.type === "".concat(_types2.START_AGORA_SCREENSHARE, "_FAILURE")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      screenShare: {
        client: null,
        videoTrack: null,
        audioTrack: null,
        status: _ScreenShareStatus.SCREEN_SHARE_STATUS.IDLE
      }
    });
  }
  if (action.type === "".concat(_types2.STOP_AGORA_SCREENSHARE, "_SUCCESS") && (_action$payload3 = action.payload) !== null && _action$payload3 !== void 0 && _action$payload3.isLocal) {
    return _objectSpread(_objectSpread({}, state), {}, {
      screenShare: {
        client: null,
        videoTrack: null,
        audioTrack: null,
        status: _ScreenShareStatus.SCREEN_SHARE_STATUS.IDLE
      }
    });
  }
  return state;
}